module.exports = __webpack_public_path__ + "img/xefe.a29e4096.png";